import styled from 'styled-components'
import { mediaMobile, mediaTablet } from '../styles/breakPoints'
import Section from './Section'
import i18n, { t, tStr } from '@utils/lang'

const StyledFooter = styled(Section)`
  background: var(--themeColorBetaBgBrown);
  min-height: 80px;
  width: 100%;
  display: flex;
  padding: 64px min(112px, 10%);
  justify-content: space-between;
  align-items: stretch;
  > div {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 16px;
  }
  img {
    display: block;
  }

  ${mediaTablet} {
    padding: 64px 80px;
  }
  ${mediaMobile} {
    padding: 64px 24px;
    flex-direction: column-reverse;
    > div + div {
      margin-bottom: 32px;
    }
  }
`

const Link = styled.a`
  color: var(--themeColorBetaSecondary);
  font-weight: var(--themeFontWeightNormal);
  text-align: left;
  white-space: nowrap;
`
const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
`

const Copyright = styled.div`
  color: var(--themeColorBetaSecondary);
  font-size: ${p => p.theme.font.size.body};
  font-weight: ${p => p.theme.font.weight.light};
  line-height: ${p => p.theme.font.lineHeight};
  a {
    padding: 0 4px;
    text-decoration: underline;
    white-space: nowrap;
  }
`

const AppHeader = styled.div`
  color: var(--themeColorBetaBrandHeader);
  font-family: ${p => p.theme.font.family.header};
  font-size: ${p => p.theme.font.size.h5};
  font-weight: ${p => p.theme.font.weight.light};
  line-height: ${p => p.theme.font.lineHeight};
  text-transform: uppercase;
`

const Footer = () => (
  <StyledFooter as="footer">
    <div>
      <img src="/images/favor.png" alt="" width={47} />
      <Links>
        <Link href="https://runnerstore.favordelivery.com/" target="_blank" rel="noreferrer">
          {t('footerGearStore_s')}
        </Link>
        <Link href="https://www.favordelivery.com/faq" target="_blank" rel="noreferrer">
          {t('footerFaqs_s')}
        </Link>
        <Link href="https://favor-runners.zendesk.com/hc/en-us" target="_blank" rel="noreferrer">
          {t('footerHelpCenter_s')}
        </Link>
        <Link href="https://rundown.favordelivery.com/" target="_blank" rel="noreferrer">
          {t('footerOurBlog_s')}
        </Link>
      </Links>
      <Copyright>
        <span>{t('footerCopyright_s', { year: new Date().getFullYear() })}</span>
        <a href="https://favordelivery.com/privacy/" target="_blank" rel="noreferrer">
          {t('privacyPolicy_s')}
        </a>
        |
        <a href="https://favordelivery.com/tos/" target="_blank" rel="noreferrer">
          {t('termsOfService_s')}
        </a>
      </Copyright>
    </div>
    <div>
      <AppHeader>{t('footerGetTheApp_s')}</AppHeader>
      <a href="https://apps.apple.com/us/app/favor-runner-deliver-earn/id1295308505">
        <img src={`/images/${i18n.locale}/AppleStore.png`} alt={tStr('appleStoreAlt_s')} />
      </a>
      <a href="https://play.google.com/store/apps/details?id=com.neighbfav.neighborfavor.runner">
        <img src={`/images/${i18n.locale}/GooglePlay.png`} alt={tStr('googlePlayAlt_s')} />
      </a>
    </div>
  </StyledFooter>
)

export default Footer
